/**
 * @generated SignedSource<<5178fbac7a16fa8329f772e49439f410>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postMoveDialogQuery$data = {
  readonly club: {
    readonly groups: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly spaces: ReadonlyArray<{
        readonly icon: string | null | undefined;
        readonly id: string;
        readonly name: string;
      }>;
    }>;
    readonly slug: string;
  };
  readonly id: string;
  readonly space: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "postMoveDialogQuery";
};
export type postMoveDialogQuery$key = {
  readonly " $data"?: postMoveDialogQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"postMoveDialogQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postMoveDialogQuery",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SpaceGroup",
          "kind": "LinkedField",
          "name": "groups",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "spaces",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "icon",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "84c94f7ba28027bc32fe8fc643cc7c74";

export default node;
